import {useState, useEffect} from "react";
function useScreenSize() {
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    useEffect(() => {
        function handleResize() {
            setScreenHeight(window.innerHeight);
            setScreenWidth(window.innerWidth);
        }
        window.addEventListener("resize", handleResize);
    }, []);
    return [screenHeight, screenWidth];
};

export default useScreenSize